import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { AppButton, FigmaTypography } from "@libs/zapi-ui/custom";
import { getRouteSettings } from "@/zapi-frontend/shared/const/router";
import { useHistoricalNavigate } from "@/zapi-frontend/shared/hooks/useHistoricalNavigate";

export function PasswordExpiryBanner() {
  const { passwordExpiringSoon, passwordExpiryDate } = useMeStore();
  const { navigate } = useHistoricalNavigate();

  if (!passwordExpiringSoon) return null;

  const expiryLabel = passwordExpiryDate
    ? new Date(passwordExpiryDate).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
    : null;

  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 px-4 py-3 flex items-center justify-between">
      <FigmaTypography variant="body-2" className="text-amber-800">
        Your password expires {expiryLabel ? `on ${expiryLabel}` : "soon"}. Please change it to avoid being locked out.
      </FigmaTypography>
      <AppButton
        data-testid="password-expiry-change-password-button"
        size="sm"
        appearance="outlined"
        onClick={() => navigate(getRouteSettings())}
        className="text-amber-700 border-amber-300 hover:bg-amber-100 bg-white"
      >
        Change Password
      </AppButton>
    </div>
  );
}
